<template>
    <v-snackbar
        v-model="show"
        data-id="notificationBar"
        class="notification-bar pb-md-6 pl-md-6 px-0 pb-3"
        :content-class="`w-100 w-md-auto pb-1 rounded border-s-md border-e-sm border-t-sm border-b-sm border-${border} border-opacity-100 pa-1`"
        :color="color"
        location="bottom left"
        :timeout="timeOut"
    >
        <div class="d-flex pa-0 text-secondary-light text-size-lg">
            <svg-icon class-names="m-0" :icon="icon" alt="info" />
            <span class="notification-bar__text align-self-end ml-2">
                {{ message }}
            </span>
        </div>
    </v-snackbar>
</template>

<script setup lang="ts">
import { IConfirmationBar } from '../types';
import { DEFAULT_TIMEOUT } from '@/constants';
import check from '@/assets/check.svg';
import SvgIcon from '@/features/common/components/SvgIcon.vue';

const show = defineModel<boolean>('show');

withDefaults(defineProps<IConfirmationBar>(), {
    timeOut: DEFAULT_TIMEOUT,
    color: 'primary-light',
    icon: check as string
});
</script>
